import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import moment from "moment-timezone";
import * as actionTypes from "../../../../store/actions/actionTypes";
import TimePeriodButton from "./TimePeriodButton/TimePeriodButton";

class TimePeriodButtons extends Component {
  updateStartDate = (id) => {
    // let startDate = new Date().getTime();
    let startDate = moment().clone().utc().startOf('day').unix() * 1000;
    switch (id) {
      // 1 day
      case 0:
        startDate = moment().clone().subtract(1, 'day').utc().startOf('day').unix() * 1000;
        // startDate -= 1 * 24 * 60 * 60 * 1000;
        break;
      // 1 week (7 days)
      case 1:
        startDate = moment().clone().subtract(7, 'days').utc().startOf('day').unix() * 1000;
        // startDate -= 7 * 24 * 60 * 60 * 1000;
        break;
      // 1 month (30 days)
      case 2:
        startDate = moment().clone().subtract(1, 'month').utc().startOf('day').unix() * 1000;
        // startDate -= 30 * 24 * 60 * 60 * 1000;
        break;
      // all (any other input behaves like all), start at beginning of unix timestamp
      case 3:
      default:
        startDate = 0;
        break;
    }
    console.log(startDate, id);
    this.props.updateStartDate(startDate, id);
  };

  render() {
    return (
      <Fragment>
        <TimePeriodButton id={0} right="205px" click={this.updateStartDate} selected={this.props.index === 0}>
          1D
        </TimePeriodButton>
        <TimePeriodButton id={1} right="145px" click={this.updateStartDate} selected={this.props.index === 1}>
          1W
        </TimePeriodButton>
        <TimePeriodButton id={2} right="85px" click={this.updateStartDate} selected={this.props.index === 2}>
          1M
        </TimePeriodButton>
        <TimePeriodButton id={3} right="25px" click={this.updateStartDate} selected={this.props.index === 3}>
          ALL
        </TimePeriodButton>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    index: state.clientDashboard.timePeriod
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateStartDate: (date, id) =>
      dispatch({
        type: actionTypes.UPDATE_START_DATE,
        startDate: date,
        index: id
      })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TimePeriodButtons);
